<template>
  <div>
    <header class="header">
      <h1 class="title">{{$t('login.header.title')}}</h1>
      <h2 class="subtitle">
        {{$t('global.orConjunction')}} <router-link :to="'register'">{{$t('global.register')}}</router-link>
      </h2>
    </header>

    <form @submit.prevent="login" novalidate>
      <fieldset class="form">
        <div class="change-city control has-icons-left">
          <div class="select is-primary">
            <select
              v-model="$root.app.city"
              @change="changeCity"
            >
              <option v-for="option in cityOptions" v-bind:key="option.code" v-bind:value="option.code">{{ option.city }} - {{ option.uf}}</option>
            </select>
          </div>
          <div class="icon is-small is-left is-pin"></div>
        </div>
        <zul-input
          :uppercase="true"
          type="text"
          v-model="user.document"
          name="document"
          key="document-input"
          icon="document"
          v-validate="'required|document'"
          :label="$t('global.form.document.title')"
          :mask="documentMask()"
        ></zul-input>
        <zul-input
          type="password"
          v-model="user.password"
          name="password"
          key="password-input"
          icon="lock"
          v-validate="'required'"
          ref="password"
          :label="$t('global.form.password.title')"
          maxlength="15"
        ></zul-input>
        <p v-if="error === 406" class="help is-danger">
          {{$t('global.loginError.406')}}
        </p>
      </fieldset>

      <div class="buttons">
        <button ref="button" class="button is-primary is-large">{{$t('login.joinButton.title')}}</button>
        <router-link :to="'forgot-password'" class="button is-text is-large"
          >{{$t('login.forgotPassword.navigation.title')}}</router-link
        >
      </div>
    </form>
    <AccessValidationModal
      @confirm="tryLoginAgain"
      :info="accessValidationInfo"
    ></AccessValidationModal>
    <OTPValidationModal
      ref="otpValidation"
      :maskedPhoneNumber="maskedPhoneNumber"
    ></OTPValidationModal>
  </div>
</template>

<script>
import config from "config";
import { getIdentifierHeaders } from "@zuldigital/utils";
import AccessValidationModal from "../../modals/AccessValidation.vue";
import OTPValidationModal from "../../modals/OTPValidation.vue";

export default {
  name: "Login",
  components: {
    AccessValidationModal,
    OTPValidationModal,
  },
  data() {
    return {
      maskedPhoneNumber: "",
      user: {},
      error: null,
      accessValidationInfo: {},
      cityOptions: [
          { "code": "AME", "uf": "SP", "city": "Americana" },
          { "code": "ARA", "uf": "SP", "city": "Araraquara" },
          { "code": "BHZ", "uf": "MG", "city": "Belo Horizonte" },
          { "code": "CWB", "uf": "PR", "city": "Curitiba" },
          { "code": "FTZ", "uf": "CE", "city": "Fortaleza" },
          { "code": "ITA", "uf": "SP", "city": "Itatiba" },
          { "code": "JAC", "uf": "SP", "city": "Jacareí" },
          { "code": "JZF", "uf": "MG", "city": "Juiz de Fora" },
          { "code": "LIM", "uf": "SP", "city": "Limeira" },
          { "code": "MAU", "uf": "SP", "city": "Mauá" },
          { "code": "MOG", "uf": "SP", "city": "Mogi das Cruzes" },
          { "code": "MON", "uf": "SP", "city": "Mongaguá" },
          { "code": "MCL", "uf": "MG", "city": "Montes Claros" },
          { "code": "RIC", "uf": "SP", "city": "Rio Claro" },
          { "code": "SSA", "uf": "BA", "city": "Salvador" },
          { "code": "SBO", "uf": "SP", "city": "Santa Bárbara D'Oeste" },
          { "code": "STA", "uf": "SP", "city": "Santo André" },
          { "code": "SBC", "uf": "SP", "city": "São Bernardo do Campo" },
          { "code": "SCA", "uf": "SP", "city": "São Carlos" },
          { "code": "SSG", "uf": "RS", "city": "São Gabriel" },
          { "code": "SBV", "uf": "SP", "city": "São João da Boa Vista" },
          { "code": "SAO", "uf": "SP", "city": "São Paulo" },
          { "code": "TAU", "uf": "SP", "city": "Taubaté" }
      ]
    };
  },
  created() {
    this.selectCityBySearchParam();
  },
  computed: {
    city() {
      return this.$root.app.city;
    },
    cityName() {
      return this.$root.app.cityName;
    },
  },
  methods: {
    changeCity($e) {
      this.$router.push("/" + $e.currentTarget.value.toLowerCase());
    },
    tryLoginAgain() {
      this.$root.$emit("close-access-validation-modal");
      this.login();
    },
    login() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (this.user.document.length > 14) {
            // NOTE: redirect simples para o Zul Corporate WEB-51
            return window.open(
              `${config.CORP_URL}?city=${this.$root.app.city}&document=${this.user.document}`,
              "_self"
            );
          }

          const $button = this.$refs.button;
          const data = new FormData();
          data.append("document", this.user.document.replace(/[./-]/g, ""));
          data.append("password", this.user.password);

          // disable button
          $button.classList.add("is-loading");

          this.$auth
            .login({
              data: data,
              headers: {
                ...getIdentifierHeaders(),
              },
              error(error) {
                const status = ((error || {}).response || {}).status;
                const data = (
                  (error || {}).response ||
                  {}.data ||
                  {}.data ||
                  {}
                ).data;

                if (status === 411) {
                  this.$root.$emit("open-access-validation-modal");
                  this.accessValidationInfo = data.data;
                } else if (status === 426) {
                  // eslint-disable-next-line no-console
                  this.maskedPhoneNumber = (
                    (data || {}).data || {}
                  ).maskedPhoneNumber;
                  this.$refs.otpValidation.checkStep(this.maskedPhoneNumber);
                  this.$root.$emit("open-otp-validation-modal");
                } else {
                  this.error = 406;
                }

                // enable button
                $button.classList.remove("is-loading");
              },
            })
            .then((res) => {
              this.$auth.user(res.data);
            });
        }
      });
    },
    documentMask() {
      const value = (this.user.document || "").replace(/[^0-9a-z]/gi, "");
      return value.length > 11 ? "NN.NNN.NNN/NNNN-##" : "NNN.NNN.NNN-NN";
    },
    selectCityBySearchParam() {
      const uri = window.location.search;
      const params = new URLSearchParams(uri);
      const cityCode = (params.get('cityCode') || '').toLowerCase();

      if(cityCode) {
        const foundCityOption = this.cityOptions.find((city) => city.code.toLowerCase() === cityCode)

        if(foundCityOption) {
          this.$router.push("/" + cityCode);
        }
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>
